import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";

export default function Footer() {
  const [organizationData, setOrganizationData] = useState({});

  useEffect(() => {
    let isMounted = true;
    const controller = new AbortController();
    
    axios.get("api/home/get_footer_data", { signal: controller.signal }).then((res) => {
      if (!isMounted) return;
      if (res.data.status === "success") {
        setOrganizationData(res.data.organization || {});
      }
    }).catch(error => {
      if (!isMounted) return;
      if (error.name !== "AbortError" && error.name !== "CanceledError") {
        console.error("Failed to load footer data:", error);
      }
    });

    // Cleanup: cancel request if component unmounts
    return () => {
      isMounted = false;
      controller.abort();
    };
  }, []);

  return (
    <footer className="sf-footer">
      <div className="container">

        {/* ── Row 1 ── */}
        <div className="sf-footer-row">

          {/* Col 1 – Brand */}
          <div className="sf-footer-brand">
            <Link to="/">
              <img src="portal/images/CompanyLogo.png" alt="Solid Future" className="sf-footer-logo" />
            </Link>
            <p className="sf-footer-desc">
              Solid Future HR Consulting Private Limited is the fastest growing
              one-stop HR solution company. Within a short span of time, Solid
              Future has been able to create a niche for itself in the HR
              solution industry through&nbsp;
              <Link to="/about" className="sf-footer-readmore">Read More...</Link>
            </p>
            <ul className="sf-footer-socials">
              <li>
                <a href={organizationData.facebook_link || "#"} target="_blank" rel="noreferrer">
                  <i className="ri-facebook-fill"></i>
                </a>
              </li>
              <li>
                <a href={organizationData.instagram_link || "#"} target="_blank" rel="noreferrer">
                  <i className="ri-instagram-line"></i>
                </a>
              </li>
              <li>
                <a href={organizationData.linkedin_link || "#"} target="_blank" rel="noreferrer">
                  <i className="ri-linkedin-fill"></i>
                </a>
              </li>
              <li>
                <a href={`https://wa.me/${organizationData.mobile || ""}`} target="_blank" rel="noreferrer">
                  <i className="ri-whatsapp-line"></i>
                </a>
              </li>
              <li>
                <a href={organizationData.viber_link || "#"} target="_blank" rel="noreferrer">
                  <i className="ri-phone-fill"></i>
                </a>
              </li>
              <li>
                <a href={`mailto:${organizationData.email || ""}`}>
                  <i className="ri-mail-line"></i>
                </a>
              </li>
            </ul>
          </div>

          {/* Col 2 – Explore Job */}
          <div className="sf-footer-col">
            <h4 className="sf-footer-heading">Explore Job</h4>
            <ul className="sf-footer-links">
              <li><Link to="/">Job Listing</Link></li>
              <li><Link to="/jobs?filter=level">Job By Level</Link></li>
              <li><Link to="/jobs?filter=nature">Job By Work Nature</Link></li>
              <li><Link to="/jobs?filter=shift">Job By Work Shift</Link></li>
              <li><Link to="/jobs?filter=type">Job By Type</Link></li>
            </ul>
          </div>

          {/* Col 3 – For Careers Seekers */}
          <div className="sf-footer-col">
            <h4 className="sf-footer-heading">For Careers Seekers</h4>
            <ul className="sf-footer-links">
              <li><Link to="/">Search Jobs</Link></li>
              <li><Link to="/jobs">Browse by Categories</Link></li>
              <li><Link to="/login?type=seeker">Jobseeker Account</Link></li>
              <li><Link to="/register">Create Account</Link></li>
            </ul>
          </div>

          {/* Col 4 – For Employers */}
          <div className="sf-footer-col">
            <h4 className="sf-footer-heading">For Employers</h4>
            <ul className="sf-footer-links">
              <li><Link to="/login?type=employer">Vacancy Annoucement</Link></li>
              <li><Link to="/pages/outsourcing">Outsourcing service</Link></li>
              <li><Link to="/pages/recruitment">Recuriment service</Link></li>
              <li><Link to="/pages/hr-consulting">Human Resource Consulting</Link></li>
            </ul>
          </div>
        </div>

        {/* ── Divider ── */}
        {/* <div className="sf-footer-divider"></div> */}

        {/* ── Row 2 ── */}
        <div className="sf-footer-row">

          {/* Col 1 – Get in Touch */}
          <div className="sf-footer-brand">
            <h4 className="sf-footer-heading">Get in Touch</h4>
            <ul className="sf-footer-contact">
              <li>
                <i className="ri-mail-line"></i>
                <span>{organizationData.email || "career@solidfuture.com.np"}</span>
              </li>
              <li>
                <i className="ri-phone-line"></i>
                <span>{organizationData.phone || "01-5705389"}</span>
              </li>
              <li>
                <i className="ri-map-pin-line"></i>
                <span>
                  {organizationData.address1
                    ? `${organizationData.address1}${organizationData.address2 ? ", " + organizationData.address2 : ""}`
                    : "Anamnagar, Kathmandu"}
                </span>
              </li>
            </ul>
          </div>

          {/* Col 2 – Trainings */}
          <div className="sf-footer-col">
            <h4 className="sf-footer-heading">Trainings</h4>
            <ul className="sf-footer-links">
              <li><Link to="/training">Professional HR Training</Link></li>
              <li><Link to="/training">Advance HR Training</Link></li>
              <li><Link to="/training">Job Oriented HR Training</Link></li>
              <li><Link to="/training">QA Training</Link></li>
            </ul>
          </div>

          {/* Col 3 – Resources */}
          <div className="sf-footer-col">
            <h4 className="sf-footer-heading">Resources</h4>
            <ul className="sf-footer-links">
              <li><Link to="/blog">Blog</Link></li>
              <li><Link to="/privacy-policy">Privacy Policy</Link></li>
              <li><Link to="/terms-and-conditions">Terms and Conditions</Link></li>
            </ul>
          </div>

          {/* Col 4 – Quick Links */}
          <div className="sf-footer-col">
            <h4 className="sf-footer-heading">Quick Links</h4>
            <ul className="sf-footer-links">
              <li><Link to="/contact-us">Contact Us</Link></li>
              <li><Link to="/about">About Us</Link></li>
              <li><Link to="/contact-us">Report a Problem</Link></li>
            </ul>
          </div>
        </div>

        {/* ── Bottom bar ── */}
        <div className="sf-footer-divider"></div>
        <div className="sf-footer-bottom">
          <span>© &nbsp;2025 &nbsp;|&nbsp; Solid Future HR Consulting Pvt. Ltd</span>
        </div>

      </div>
    </footer>
  );
}
